// ---------------------------------------------------------------------------
// Singleton API client instance for the admin-web app
// ---------------------------------------------------------------------------

import { createNoxVerifyClient } from '@noxverify/api-client';

const API_BASE = import.meta.env.VITE_API_BASE_URL || '';

export const api = createNoxVerifyClient({
  baseUrl: API_BASE,
  // In production, Cloudflare Access handles auth via cookies.
  // In development, the x-debug-principal header is set via setDebugPrincipal().
});

// ---------------------------------------------------------------------------
// Debug principal — development-only auth header injection
// ---------------------------------------------------------------------------

let _currentUser: { id: string; type: string; email?: string; tenantId?: string } | null = null;

/**
 * Store the current user for development-mode debug header injection.
 * Called by AuthProvider on login/logout to keep the debug principal in sync.
 */
export function setDebugPrincipal(
  user: { id: string; type: string; email?: string; tenantId?: string } | null,
): void {
  _currentUser = user;
}

/**
 * Returns the `x-debug-principal` header for development-mode API calls.
 * Returns an empty object when no user is set (production path or logged out).
 */
export function getDebugHeaders(): Record<string, string> {
  if (!_currentUser) return {};
  return { 'x-debug-principal': JSON.stringify(_currentUser) };
}
